import React from 'react';
import '../../styles/components/warning-box.scss';
import { AlertTriangle } from 'lucide-react';
import i18n from '../../i18n';

export class WarningBox extends React.Component {
  handleApprove = () => {
    this.props.onApprove?.();
  };

  handleReject = () => {
    this.props.onReject?.();
  };

  handleDeduct = () => {
    this.props.onDeduct?.();
  };

  render() {
    const { message, onReject, onDeduct, approveText, rejectText, deductText } = this.props;

    return (
      <div className="warning-box">
        <div className="warning-content">
          <div className="warning-icon">
            <AlertTriangle size={22} color="#ffb400" />
          </div>
          <div className="warning-message">
            {message || 'Refund Warning. Please review carefully before proceeding.'}
          </div>
          <div className="warning-buttons">
            <button type="button" className="btn-approve" onClick={this.handleApprove}>
              {approveText || i18n.t('approve')}
            </button>

            {/* Reject only shows if onReject prop exists */}
            {onReject && (
              <button type="button" className="btn-reject" onClick={this.handleReject}>
                {rejectText || i18n.t('reject')}
              </button>
            )}

            {/* Deduction only shows if onDeduct prop exists */}
            {onDeduct && (
              <button type="button" className="btn-deduct" onClick={this.handleDeduct}>
                {deductText || i18n.t('deduction') || 'Deduction'}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}
